import UserModel from '../../models/user/UserModel.js';

const UserCollection = Backbone.Collection.extend({
  name: 'users',
  model: UserModel,
  defaults: {
    query: 'unknown',
  },
  initialize() {

  },
  sync(method, collection, options) {
    // Possible methods: create, read, update, dete
    const $username = loginContext.getDefaultLoginDetails().username;
    const cache = new Cache();
    const _this = this;
    let key;
    const defer = $.Deferred();

    if (typeof options === 'undefined') {
      options = {};
    }

    if (!options.hasOwnProperty('concise')) {
      options.concise = false;
    }

    key = `${$username}_users${options.concise ? '_concise' : ''}`;

    if (typeof options.profile !== 'undefined') {
      key += `_${options.profile}`;
    }

    // options.reset = ( method === "read" ) ? false : true; // update takes boolean, if set true update function will be called. Update cannot be called with data
    options.reset = (options.reset === undefined ? true : options.reset);

    if (method == 'read') {
      if (cache.read(key) == null || options.ignoreCache) {
        let params = {};

        params = $.extend(true, {}, _.omit(options, ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache', 'setPermissionData', 'ignoreCache', 'user_id']));

        if (!params.page) {
          params.page = 1;
        }

        const successHandler = (data) => {
          if (typeof data.users === 'undefined') {
            data.users = data;
          }

          _this.pageCount = data.pageCount || 1;
          _this.totalResults = data.totalResults || 0;
          _this.totalPages = _this.totalResults == 0 ? 0 : Math.ceil(_this.totalResults / window.appConfig.usersPerPage);

          if (options.setPermissionData) {
            _this.setPermissionData(data.users, options.defaultProfileSetting);
          }

          // dont cache if a filtered search
          if (!params.filter && !params.advanced_filter && !options.ignoreCache) {
            cache.store(key, JSON.stringify(data), 5); // refresh user cache every 5 days
          }

          options.success(data.users);
          defer.resolve(data.users);
        };

        const errorHandler = (data) => {
          options.error(data);
          defer.reject(data);
        };

        if (options.useV2Endpoint) {
          return Sendible.Connect.getUsersV2(
            window.appConfig.applicationId,
            $username,
            $password,
            successHandler,
            errorHandler,
            params,
          );
        }

        return Sendible.Connect.getUsers(
          window.appConfig.applicationId,
          $username,
          $password,
          successHandler,
          errorHandler,
          params,
        );
      }

      setTimeout(() => {
        const data = JSON.parse(cache.read(key));

        if (data && typeof data.users === 'undefined') {
          data.users = data;
        }

        _this.pageCount = data.pageCount || 1;
        _this.totalResults = data.totalResults || 0;

        options.success(data.users);
        defer.resolve(data.users);
      }, 0);
    }
    const promise = defer.promise();
    return promise;
  },
  clearCache() {
    const $username = loginContext.getDefaultLoginDetails().username;
    const cache = new Cache();
    const key1 = `${$username}_users_concise`;
    const key2 = `${$username}_users_concise_Active`;
    const key3 = `${$username}_users`;

    if (cache.read(key1) !== null) {
      cache.remove(key1);
    }

    if (cache.read(key2) !== null) {
      cache.remove(key2);
    }

    if (cache.read(key3) !== null) {
      cache.remove(key3);
    }
  },
  setPermissionData(users, defaultProfileSetting) {
    _.each(users, (user) => {
      if (user.permission_profile) {
        user.permissionName = user.permission_profile.profile_name;
        user.permissionId = user.permission_profile.id;
      } else if (defaultProfileSetting) {
        user.permissionName = defaultProfileSetting.permissionName;
        user.permissionId = defaultProfileSetting.permissionId;
      } else {
        user.permissionName = 'Default';
      }
    });
  },
  setPermissionNamesOnModels(users) {
    _.each(users, (user) => {
      const permissionName = user.attributes.permission_profile ? user.attributes.permission_profile.profile_name : 'Default';
      user.set({ permissionName });
    });
  },
  setUserHierarchy() {
    let userHierarchy = 0;
    let arManagers = [];
    let prevUser;

    this.each((user) => {
      const userJSON = user.toJSON();

      user.set('hasSubUsers', false);

      // this code calculates the indent based on user
      // hierarchy
      if (userJSON.parent_user_id !== null) {
        if (arManagers.indexOf(userJSON.parent_user_id) === -1) {
          arManagers.push(userJSON.parent_user_id);
        }

        // set hasSubUsers
        if (prevUser && prevUser.get('userHierarchy') === 0) {
          prevUser.set('hasSubUsers', true);
        }

        userHierarchy = arManagers.indexOf(userJSON.parent_user_id) + 1;
      } else {
        arManagers = [];
        userHierarchy = 0;
        prevUser = user;
      }

      user.set('userHierarchy', userHierarchy);
    });
  },
  parse(data) {
    return data;
  },

});

export default UserCollection;
